import { render, staticRenderFns } from "./authenticationList.vue?vue&type=template&id=3044c0a8&scoped=true"
import script from "./authenticationList.vue?vue&type=script&lang=js"
export * from "./authenticationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3044c0a8",
  null
  
)

export default component.exports